import { FC, SVGProps } from 'react'

export const IconFolderTree: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    stroke="#0062CA"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.9167 19.1667H38.3333C38.8417 19.1667 39.3292 18.9647 39.6886 18.6053C40.0481 18.2458 40.25 17.7583 40.25 17.25V11.5C40.25 10.9917 40.0481 10.5042 39.6886 10.1447C39.3292 9.78527 38.8417 9.58333 38.3333 9.58333H33.5417C33.2441 9.58333 32.9506 9.51406 32.6845 9.38099C32.4184 9.24792 32.1869 9.05471 32.0083 8.81667L30.2833 6.51667C30.1048 6.27862 29.8733 6.08542 29.6072 5.95235C29.341 5.81928 29.0476 5.75 28.75 5.75H24.9167C24.4083 5.75 23.9208 5.95193 23.5614 6.31138C23.2019 6.67082 23 7.15834 23 7.66667V17.25C23 17.7583 23.2019 18.2458 23.5614 18.6053C23.9208 18.9647 24.4083 19.1667 24.9167 19.1667Z"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.9167 40.25H38.3333C38.8417 40.25 39.3292 40.048 39.6886 39.6886C40.0481 39.3291 40.25 38.8416 40.25 38.3333V32.5833C40.25 32.075 40.0481 31.5875 39.6886 31.228C39.3292 30.8686 38.8417 30.6666 38.3333 30.6666H32.8133C32.4561 30.6691 32.1053 30.5717 31.8005 30.3855C31.4958 30.1992 31.2491 29.9315 31.0883 29.6125L30.245 27.8875C30.0843 27.5685 29.8376 27.3007 29.5328 27.1145C29.228 26.9282 28.8772 26.8308 28.52 26.8333H24.9167C24.4083 26.8333 23.9208 27.0352 23.5614 27.3947C23.2019 27.7541 23 28.2416 23 28.75V38.3333C23 38.8416 23.2019 39.3291 23.5614 39.6886C23.9208 40.048 24.4083 40.25 24.9167 40.25Z"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.75 5.75V9.58333C5.75 11.6917 7.475 13.4167 9.58333 13.4167H15.3333"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.75 5.75V30.6667C5.75 32.775 7.475 34.5 9.58333 34.5H15.3333"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
